@if (icon) {
    <div  [ngClass]="{'invisible': !visible}" class="v3 d-flex svg-icon">
        <div class="d-flex align-items-center justify-content-center svg-icon-container" 
            [ngClass]="size" 
            [matTooltip]="toolTipText"  
            matTooltipPosition="after" 
            #tooltip="matTooltip">
            @if (icon.Path) {
                <span [class.sb-icon-fill-override]="fill" [style.--sb_icon-fill]="fill"
                    [attr.data-sb-qa]="qaTag" 
                    [innerHTML]="icon.Path | trustHtml">
                </span>
            }
        </div>
    </div>
}

